const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate joinDefinedBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const {
    separator = ', '
  } = source;
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values && values.length) {
    const filteredValues = values.filter(item => item !== undefined && item !== null);
    if (filteredValues.length > 0) {
      return filteredValues.join(separator);
    }
  }
  return undefined;
};
module.exports = {
  evaluate
};